import { Link, useNavigate } from "react-router-dom";
import { backendImageUrl, RoutesPaths } from "../Router/constant";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentLoader from "react-content-loader";
import Modal from "react-bootstrap/Modal";
import { categoryListDeleteAction } from "../actions/category";
import { bannerDetails, bannerListDeleteAction } from "../actions/banner";

export default function Banner() {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bannerList, bannerListLoader } = useSelector((state) => state.banner);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [show, setShow] = useState(false);
  const [isBannerId, setIsBannerId] = useState();
  const [type, setType] = useState("");

  useEffect(() => {
    const delay = setTimeout(() => {
      dispatch(bannerDetails(search, page, limit, type));
    }, 500);

    return () => clearTimeout(delay);
  }, [dispatch, search, page, type]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [bannerList]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleDelete = (id) => {
    setIsBannerId(id);
    setShow(true);
  };
  const handleClose = () => setShow(false);
  const totalPages = bannerList?.pagination?.totalPages || 1;
  const handleSearch = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };

  const handleEdit = (id) => {
    setIsBannerId(id);
    navigate(RoutesPaths.EDITBANNER.replace(":id", id), {});
  };

  const handleConfirmDelete = async () => {
    const resp = await dispatch(bannerListDeleteAction(isBannerId));
    if (resp.status === 200) {
      dispatch(bannerDetails(search, page, limit, type)); setShow(false);
    } else {
      setShow(false);
    }
  };

  const getPagination = (page, totalPages) => {
    const pages = [];

    // Always show first page
    pages.push(1);

    // Left dots
    if (page > 2) {
      pages.push("...");
    }

    // Current & next page
    if (page > 1 && page < totalPages) {
      pages.push(page);
    }

    if (page + 1 < totalPages) {
      pages.push(page + 1);
    }

    // Right dots
    if (page + 2 < totalPages) {
      pages.push("...");
    }

    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return [...new Set(pages)];
  };

  return (
    <>
      {bannerListLoader ? (
        <div className="container-fluid contactSkeleton">
          {[...Array(6)].map((_, i) => (
            <ContentLoader key={i} width="100%" height={50}>
              <rect x="0" y="0" rx="5" ry="5" width="100%" height="50" />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <div className="container-fluid mainConatinerSection">
          <div className="card card-flush">
            <div className="card-header align-items-center py-5 gap-2 gap-md-5">
              <div className="card-title">
                <div className="d-flex align-items-center position-relative my-1">
                  <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
                    <span className="path1 searchPath"></span>
                    <span className="path2 searchPath"></span>
                  </i>
                  <input
                    ref={inputRef}
                    type="text"
                    className="form-control form-control-solid w-250px ps-12"
                    placeholder="Search banner"
                    value={search}
                    onChange={handleSearch}
                  />
                </div>
              </div>

              <div className="card-toolbar d-flex align-items-center gap-3">
                <select
                  className="form-select w-auto min-w-150px"
                  value={type}
                  onChange={(e) => {
                    setPage(1);
                    setType(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  <option value="main">Main</option>
                  <option value="category">Category</option>
                  <option value="store">Store</option>
                  <option value="external">External</option>
                </select>
                <Link to={RoutesPaths.ADDBANNER} className="btn buttonPrimary">
                  Add banner
                </Link>
              </div>
            </div>
            <div className="card-body pt-0 overFlowScroll">
              <table className="table align-middle table-row-dashed fs-6 gy-5">
                <thead>
                  <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                    <th className="categoryWidth">Banner Image</th>
                    <th className="text-center">Created Date</th>
                    <th className="text-center min-w-70px">Actions</th>
                  </tr>
                </thead>
                <tbody className="fw-semibold text-gray-600">
                  {bannerList?.data?.length > 0 ? (
                    bannerList.data.map((item, index) => (
                      <tr key={item._id || index}>
                        <td className="categoryWidth">
                          <div className="d-flex">
                            <Link to="#" className="symbol symbol-50px">
                              <span
                                className="symbol-label bannerImage"
                                style={{
                                  backgroundImage: `url(${backendImageUrl + item?.image?.fileName
                                    })`,
                                }}
                              />
                            </Link>

                            <div className="ms-5">
                              <Link
                                to="#"
                                className="text-gray-800 text-hover-primary fs-5 fw-bold mb-1"
                              >
                                {item.name}
                              </Link>
                              <div className="text-muted fs-7 fw-bold">
                                {item.description}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="text-center">
                          {formatDate(item.createdAt)}
                        </td>

                        <td className="text-center min-w-70px">
                          <button
                            className="btn btn-sm btn-light me-2"
                            onClick={() => handleEdit(item._id)}
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-sm btn-light-danger"
                            onClick={() => handleDelete(item._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-5 text-muted">
                        No banners found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* Pagination */}
              {bannerList?.data?.length > 0 && (
                <div className="row mt-4">
                  <div className="col-md-5">
                    <strong>Total: {bannerList?.pagination?.total}</strong>
                  </div>

                  <div className="col-md-7 d-flex justify-content-end">
                    <ul className="pagination">
                      {/* Prev */}
                      {page > 1 && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page - 1)}
                          >
                            Prev
                          </button>
                        </li>
                      )}

                      {getPagination(page, totalPages).map((item, index) => (
                        <li
                          key={index}
                          className={`page-item ${item === page ? "activePagination" : ""
                            } ${item === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            disabled={item === "..."}
                            onClick={() => item !== "..." && setPage(item)}
                          >
                            {item}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      {page < totalPages && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page + 1)}
                          >
                            Next
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
              {/* End Pagination */}
            </div>
          </div>
        </div>
      )}
      <Modal show={show} onHide={handleClose}>
        <div className="LogoutSection">
          <h6 className="m-0">Delete</h6>
          <p className="m-0">Are you sure you want to delete this banner?</p>
          <div className="logoutbuttonSection">
            <button
              className="redButton fontBthSize"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="greenButton fontBthSize"
              variant="primary"
              onClick={handleConfirmDelete}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
